import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
  Form,
  CardImg,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Dropzone from "react-dropzone";
import Select from "react-select";
import moment from "moment";
import { Link } from "react-router-dom";
import _, {  isObject} from "lodash";
import { CircularProgress } from "@material-ui/core";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";
import { frxAppOptions } from "../../common/constants";


const AddWidget = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];
  const estoreSubSections = [
    {
      section: "/show-all",
      value: "StoreMainScreen",
      label: "Store Listing",
      type: "showStores",
      campaignMedium: "SplashBanner",
      link: "",
      comingFromStore: true,
      url: "",
    },
    {
      section: "/show-all",
      value: "StoreMainScreen",
      label: "Category Listing",
      campaignMedium: "SplashBanner",
      link: "",
      hidden: true,
      url: "",
    },
    { section: "", value: "StoreMainScreen", label: "No Navigation" },
  ];
  const categoryOptionGroup = [];
  let merchantOptionGroup = [];
  let secondLevelCategories = [];

  const [title, setTitle] = useState("");
  const [imageUrl, setImageUrl] = useState();
  const [position, setPosition] = useState();
  const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [navigation, setNavigation] = useState({});
  const [selectedFRXSection, setselectedFRXSection] = useState(frxAppOptions[frxAppOptions.length-1]);
  const [selectedSubSectionFRX, setselectedSubSectionFRX] = useState([]);
  const [selectedCategoryFRX, setSelectedCategoryFRX] = useState([]);
  const [categoryOption, setCategoryOptions] = useState([]);
  const [merchantOption, setMerchantOptions] = useState([]);
  const [externalUrl,setExternalUrl]=useState()
  const [loader,setLoader]=useState(false)
  const [customCheck,setcustomCheck]=useState()
  const [customNavigation,setCustomNavigation]=useState(JSON.stringify({"section":"","custom":true}))


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);

    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      const data = props?.location?.state?.item;
      let sec = data ? JSON.parse(data?.nav_to) : "";
     if(sec?.params?.show_add_selection_modal){
     setselectedFRXSection({ label: "Add Gift Card", value: "add_gift_card"})
     }else if(sec?.params?.show_buy_selection_modal){
        setselectedFRXSection({ label: "Buy Gift Card", value: "buy_gift_card"})
     }else{      
      setselectedFRXSection(
      (state) => frxAppOptions.filter((item) => sec.section == item.value)[0]
    );}
    if(sec?.url){
      setExternalUrl(sec?.url)
    }
    handleEditChanges(data);
      var navigation = props.location.state?.item?.nav_to;
      var title =props.location.state?.item?.title
      var imageUrl = props.location.state?.item?.icon_img;
      var position = props.location.state?.item?.sort_order;
      var status = props.location.state?.item?.item_status;
      setTitle(title)
      setImageUrl(imageUrl);
      setPosition(position);
      setStatus(status);
    }
  }, []);

  useEffect(() => {
    if(props?.location?.state?.edit){
      const data = props?.location?.state?.item;
      handleEditChanges(data);
    }

  }, [categoryOption, merchantOption]);
  const handleEditChanges = (data) => {
    let navigation1 = {};
    navigation1 = JSON.parse(data?.nav_to);
    if(navigation1?.custom){
      setcustomCheck(true)
      setCustomNavigation(props?.location?.state?.item?.nav_to)
    }
    else {
      // setcustomCheck(false)
      setCustomNavigation(JSON.stringify({"section":"","custom":true})) 
      if (data?.nav_to?.includes("{")) {
      setNavigation(navigation1);

      merchantOption?.length > 0 && merchantOption?.map((item) => {
        if (item.value === navigation?.params?.eStoreParams?.ID) {
          setSelectedCategoryFRX(item)
        }
      })
      categoryOption?.length > 0 && categoryOption?.map((item) => {
        if (item?.value === navigation?.params?.ID) {
          setSelectedCategoryFRX(item)
        }
      })
      if (navigation?.params?.nav_to == "/blog") {
        setselectedSubSectionFRX({ section: "/blog", value: "StoreMainScreen", label: "Blog", blog_ID: '' })
      } else if (navigation?.params?.eStoreParams?.comingFromStore) {
        setselectedSubSectionFRX({ section: "/show-all", value: "StoreMainScreen", label: "Store Listing", type: "showStores", comingFromStore: true })
      } else if (navigation?.params?.hasOwnProperty("cat_name")) {
        setselectedSubSectionFRX({ section: "/show-all", value: "StoreMainScreen", label: "Category Listing" })
      } else if (navigation?.params?.nav_to == "") {
        setselectedSubSectionFRX({ section: "", value: "StoreMainScreen", label: "No Navigation" })
      }
    }

    if (data?.nav_to?.includes("{")) {
      if(navigation1?.params?.show_add_selection_modal){
        setselectedFRXSection({ label: "Add Gift Card", value: "add_gift_card"})
        }else if(navigation1?.params?.show_buy_selection_modal){
           setselectedFRXSection({ label: "Buy Gift Card", value: "buy_gift_card"})
        }else{
          frxAppOptions?.map((item) => {
          if (item?.value == navigation1?.section) {
            setselectedFRXSection(item);
            return;
          }
        });}
      
    } else {
      frxAppOptions?.map((item) => {
        if (item.value == data?.nav_to) {
          setselectedFRXSection(item);
        } else {
          if (data?.nav_to.includes("")) {
            setselectedFRXSection({ label: "No Navigation", value: "" });
            return;
          }
        }
      });
    }}
  };

  const handleSubmit = () => {
    const link = document.getElementById("campaign_link_input")?.value ? document.getElementById("campaign_link_input")?.value:"";
    const blog_id = document.getElementById("blog_input")
      ? document.getElementById("blog_input").value
      : "";
    const blog_name = document.getElementById("blog_name_input")
      ? document.getElementById("blog_name_input").value
      : "";
    const article_id = document.getElementById("article_id")?.value;
    const titleFRX = document
      .getElementById("title_input_frx")
      ?.value
    if (!position) {
      setErrorMessage("Please Enter Position");
      setErrorAlert(true);
      return;             
    }else if (!title) {
      setErrorMessage("Please Enter Title");
      setErrorAlert(true);
      return;
    } else if (selectedFiles.length < 1) {
      setErrorMessage("Please select image");
      setErrorAlert(true);
      return;
    } else if (!status) {
      setErrorMessage("Please Select Status");
      setErrorAlert(true);
      return;
    }else if(customCheck){
      if(!customNavigation){
        setErrorMessage("Please Enter Navigation")
        setErrorAlert(true)
        return
      }
  }

    setLoader(true)
    let _deeplinkObjFRX = {
      section: "",
      params: {
        eStoreParams: {},
      },
    };
    if (selectedFRXSection) {
      _deeplinkObjFRX.section = selectedFRXSection.value;
      _deeplinkObjFRX.params.CampaignMedium = "PartnerReward";
      _deeplinkObjFRX.params.Link = link;

      if (selectedFRXSection.value == "ewallet") {
        _deeplinkObjFRX.params = selectedFRXSection.params;
      }else if (selectedFRXSection.value == "NA") {
        _deeplinkObjFRX={}
        _deeplinkObjFRX.section = "NA";
        _deeplinkObjFRX.url=externalUrl;
      }else if (selectedFRXSection.value == "UobUni") {
        _deeplinkObjFRX.section = "UobUni";
      }else if (selectedFRXSection.value == "ShowQR") {
        _deeplinkObjFRX.section = "ShowQR";
      }else if (selectedFRXSection.value == "digital_gift_card") {
        _deeplinkObjFRX.section = "digital_gift_card";
        _deeplinkObjFRX.params._params ="digital_gift_card_listing";
      }
      else if (selectedFRXSection.value == "add_gift_card") {
        _deeplinkObjFRX.section = "digital_gift_card";
        _deeplinkObjFRX.params.show_add_selection_modal = true;
      }else if (selectedFRXSection.value == "buy_gift_card") {
        _deeplinkObjFRX.section = "digital_gift_card";
        _deeplinkObjFRX.params.show_buy_selection_modal = true;
      } else if (selectedFRXSection.value == "ArticleDetail") {
        _deeplinkObjFRX.params.data = article_id;
        _deeplinkObjFRX.params.title = titleFRX;
        _deeplinkObjFRX.params.article = {
          category: titleFRX,
          id: article_id,
        };
      } else if (selectedFRXSection.value == "RewardsTab") {
        _deeplinkObjFRX.params.Link = link;
      } else if (selectedFRXSection.value == "StoreMainScreen") {
        if (selectedSubSectionFRX?.label == "Store Listing") {
          _deeplinkObjFRX.params.eStoreParams.comingFromStore =
            selectedSubSectionFRX?.comingFromStore;
          _deeplinkObjFRX.params.eStoreParams.screenName =
            selectedCategoryFRX?.label;
          _deeplinkObjFRX.params.eStoreParams.ID = selectedCategoryFRX?.value;
          _deeplinkObjFRX.params.eStoreParams.img =
            selectedCategoryFRX?.image;
          _deeplinkObjFRX.params.eStoreParams.type =
            selectedSubSectionFRX?.type;
        } else if (selectedSubSectionFRX?.label == "Category Listing") {
          _deeplinkObjFRX.section = selectedSubSectionFRX.value;
          _deeplinkObjFRX.params.url = `${process.env.REACT_APP_ESTORE_URL}`;
          _deeplinkObjFRX.params.tab = 3;
          _deeplinkObjFRX.params.nav_to = selectedSubSectionFRX?.section;
          _deeplinkObjFRX.params.hidden = selectedCategoryFRX?.hidden;
          _deeplinkObjFRX.params.screenName = selectedCategoryFRX?.label;
          _deeplinkObjFRX.params.cat_name = selectedCategoryFRX?.label;
          _deeplinkObjFRX.params.comingFromCategory = true;
          _deeplinkObjFRX.params.img = selectedCategoryFRX?.image;
          _deeplinkObjFRX.params.ID = selectedCategoryFRX?.ID;
        } else if (selectedSubSectionFRX?.label == "Blog") {
          _deeplinkObjFRX.section = "StoreMainScreen";
          _deeplinkObjFRX.params.tab = 3;
          _deeplinkObjFRX.params.eStoreParams.blog_ID = blog_id;
          _deeplinkObjFRX.params.eStoreParams.blog_name = blog_name;
          _deeplinkObjFRX.params.eStoreParams.ID = blog_id;
          _deeplinkObjFRX.params.nav_to = "/blog";
          _deeplinkObjFRX.params.url = `${process.env.REACT_APP_ESTORE_URL}`;
        } else if (selectedSubSectionFRX?.label == "No Navigation") {
          _deeplinkObjFRX.section = "StoreMainScreen";
          _deeplinkObjFRX.params.tab = 3;
          _deeplinkObjFRX.params.nav_to = "";
          _deeplinkObjFRX.params.eStoreParams = {};
          _deeplinkObjFRX.params.url = `${process.env.REACT_APP_ESTORE_URL}`;
        }
      } else if (selectedFRXSection.value == "No Navigation") {
        _deeplinkObjFRX = " ";
      }else if (selectedFRXSection.value == "BuyForMySelf") {
        _deeplinkObjFRX.params.buy_for="me"
     }
    }
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("sort_order", position);
    formdata.append("title", title);
    formdata.append("nav_to",customCheck ? customNavigation : selectedFRXSection ? JSON.stringify(_deeplinkObjFRX):{});
    formdata.append("icon_img", selectedFiles[0], selectedFiles[0].path);
    formdata.append("sort_order", position);
    formdata.append("created_datetime", currentDate);
    formdata.append("item_status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/widgets`, requestOptions)
      .then((response) => {
        if (response.status == 201) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        response.json();
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const handleEdit = () => {
    const link = document.getElementById("campaign_link_input")?.value ? document.getElementById("campaign_link_input")?.value:"";
    const blog_id = document.getElementById("blog_input")
      ? document.getElementById("blog_input").value
      : "";
    const blog_name = document.getElementById("blog_name_input")
      ? document.getElementById("blog_name_input").value
      : "";
    const article_id = document.getElementById("article_id")?.value;
    const titleFRX = document
      .getElementById("title_input_frx")
      ?.value
    if (!position) {
      setErrorMessage("Please Enter Position");
      setErrorAlert(true);
      return;
    } else if (!status) {
      setErrorMessage("Please Select Status");
      setErrorAlert(true);
      return;
    } else if (!title) {
      setErrorMessage("Please Enter Title");
      setErrorAlert(true);
      return;
    }else if(customCheck){
      if(!customNavigation){
        setErrorMessage("Please Enter Navigation")
        setErrorAlert(true)
        return
      }
  }else if(!customCheck){
    if(!selectedFRXSection){
      setErrorMessage("Please Select Navigation")
      setErrorAlert(true)
      return
    }
  }

    setLoader(true)
    let _deeplinkObjFRX = {
      section: "",
      params: {
        eStoreParams: {},
      },
    };
    if(!customCheck){
      if (selectedFRXSection) {
        _deeplinkObjFRX.section = selectedFRXSection.value;
        _deeplinkObjFRX.params.CampaignMedium = "PartnerReward";
        _deeplinkObjFRX.params.Link = link;
  
        if (selectedFRXSection.value == "ewallet") {
          _deeplinkObjFRX.params = selectedFRXSection.params;
        }else if (selectedFRXSection.value == "NA") {
          _deeplinkObjFRX={}
          _deeplinkObjFRX.section = "NA";
          _deeplinkObjFRX.url=externalUrl;
        }else if (selectedFRXSection.value == "UobUni") {
          _deeplinkObjFRX.section = "UobUni";
        }else if (selectedFRXSection.value == "ShowQR") {
          _deeplinkObjFRX.section = "ShowQR";
        }else if (selectedFRXSection.value == "digital_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params._params ="digital_gift_card_listing";
        }
        else if (selectedFRXSection.value == "add_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params.show_add_selection_modal = true;
        }else if (selectedFRXSection.value == "buy_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params.show_buy_selection_modal = true;
        } else if (selectedFRXSection.value == "ArticleDetail") {
          _deeplinkObjFRX.params.data = article_id;
          _deeplinkObjFRX.params.title = titleFRX;
          _deeplinkObjFRX.params.article = {
            category: titleFRX,
            id: article_id,
          };
        } else if (selectedFRXSection.value == "RewardsTab") {
          _deeplinkObjFRX.params.Link = link;
        } else if (selectedFRXSection.value == "StoreMainScreen") {
          if (selectedSubSectionFRX?.label == "Store Listing") {
            _deeplinkObjFRX.params.eStoreParams.comingFromStore =
              selectedSubSectionFRX?.comingFromStore;
            _deeplinkObjFRX.params.eStoreParams.screenName =
              selectedCategoryFRX?.label;
            _deeplinkObjFRX.params.eStoreParams.ID = selectedCategoryFRX?.value;
            _deeplinkObjFRX.params.eStoreParams.img =
              selectedCategoryFRX?.image;
            _deeplinkObjFRX.params.eStoreParams.type =
              selectedSubSectionFRX?.type;
          } else if (selectedSubSectionFRX?.label == "Category Listing") {
            _deeplinkObjFRX.section = selectedSubSectionFRX.value;
            _deeplinkObjFRX.params.url = `${process.env.REACT_APP_ESTORE_URL}`;
            _deeplinkObjFRX.params.tab = 3;
            _deeplinkObjFRX.params.nav_to = selectedSubSectionFRX?.section;
            _deeplinkObjFRX.params.hidden = selectedCategoryFRX?.hidden;
            _deeplinkObjFRX.params.screenName = selectedCategoryFRX?.label;
            _deeplinkObjFRX.params.cat_name = selectedCategoryFRX?.label;
            _deeplinkObjFRX.params.comingFromCategory = true;
            _deeplinkObjFRX.params.img = selectedCategoryFRX?.image;
            _deeplinkObjFRX.params.ID = selectedCategoryFRX?.ID;
          } else if (selectedSubSectionFRX?.label == "Blog") {
            _deeplinkObjFRX.section = "StoreMainScreen";
            _deeplinkObjFRX.params.tab = 3;
            _deeplinkObjFRX.params.eStoreParams.blog_ID = blog_id;
            _deeplinkObjFRX.params.eStoreParams.blog_name = blog_name;
            _deeplinkObjFRX.params.eStoreParams.ID = blog_id;
            _deeplinkObjFRX.params.nav_to = "/blog";
            _deeplinkObjFRX.params.url = `${process.env.REACT_APP_ESTORE_URL}`;
          } else if (selectedSubSectionFRX?.label == "No Navigation") {
            _deeplinkObjFRX.section = "StoreMainScreen";
            _deeplinkObjFRX.params.tab = 3;
            _deeplinkObjFRX.params.nav_to = "";
            _deeplinkObjFRX.params.eStoreParams = {};
            _deeplinkObjFRX.params.url = `${process.env.REACT_APP_ESTORE_URL}`;
          }
        } else if (selectedFRXSection.value == "No Navigation") {
          _deeplinkObjFRX = " ";
        }else if (selectedFRXSection.value == "BuyForMySelf") {
          _deeplinkObjFRX.params.buy_for="me"
       }
      }
    }



    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    // myHeaders.append(
    //   "Cookie",
    //   "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    // );

    var formdata = new FormData();
    formdata.append("id", propsData?.item?.id);
    formdata.append("_method","put");
    formdata.append("nav_to",customCheck ? customNavigation :  selectedFRXSection ? JSON.stringify(_deeplinkObjFRX) :{});
    formdata.append("title", title);
    if (!imageUrl) {
      formdata.append("icon_img", selectedFiles[0], selectedFiles[0].path);
    }
    formdata.append("sort_order", position);
    formdata.append("item_status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      mimeType: "multipart/form-data",
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/widgets/update`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props?.history.push("/widgets");
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >

        {props?.location?.state?.edit?"Widget Updated":" New Widget Added"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const validateFileSize = (file) => {
    console.log("here is the validate file----->",file)
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();
      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;
          if (width !== 70 || height !== 70) {
            setErrorMessage("Height and Width must be 70X70px")
            setErrorAlert(true)
          }else{
            handleAcceptedFiles(file)
          }
      };
    };
  }
  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    let path = files[0].path
    path = path.split(".")
    path = path[1]
    if (path == "PNG" || path == "png") {
      setSelectedFiles(files)
      setImageUrl('')
    } else {
      setErrorMessage("Please select a .png file")
      setErrorAlert(true)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Add Widget" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          {" "}
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Position</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  onChange={(e) => {
                                    setPosition(e.target.value);
                                  }}
                                  type="number"
                                  id="sort_input"
                                  defaultValue={position}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Title</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="label_name_input"
                                onChange={(e) => {
                                  setTitle(e.target.value);
                                }}
                                defaultValue={title}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Form>
                                <Row>
                                  <Col lg={4} md={10} sm={10}>
                                    <div className="mb-3">
                                      <Label>Navigate To</Label>
                                      {customCheck ? 
                                        <textarea
                                        rows={4}
                                        col={20}
                                        type="text"
                                        className="form-control"
                                        id="item_group_input"
                                        onChange={(e) => {
                                          setCustomNavigation(e.target.value);
                                        }}
                                        defaultValue={customNavigation}
                                      />
                                      :<Select
                                        isSearchable={true}
                                        value={selectedFRXSection}
                                        onChange={(e) => {
                                          setselectedFRXSection(e);
                                        }}
                                        placeholder={
                                          selectedFRXSection?.label
                                            ? selectedFRXSection?.label
                                            : "Choose section..."
                                        }
                                        defaultValue={frxAppOptions[0]}
                                        options={frxAppOptions}
                                        maxMenuHeight={120}
                                        menuPlacement="auto"
                                        required
                                      />}
                                    </div>
                                  </Col>
                                  <Col md={1}></Col>
                                  <Col md={2} style={{paddingTop:"38px"}}>
                                  <div className="form-check form-switch">
                                    <input
                                      type="checkbox"
                                      className="form-check-input checkbox"
                                      id="checkbox_custom_nav"
                                      value={customCheck}
                                      defaultChecked={customCheck}
                                      onClick={() => { 
                                      setcustomCheck(!customCheck)
                                      }}
                                    />
                                    <label className="form-check-label" htmlFor="checkbox_pocuno">
                                      Custom Navigation
                                    </label>
                                  </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={4} md={6} sm={6}>
                                    {(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck) &&<div className="mb-3">
                                      <Label>Campaign Tracking Name</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={
                                          isObject(navigation) &&
                                          navigation?.params?.Link
                                        }
                                        id="campaign_link_input"
                                        // onChange={(e) => setFrxApp(true)
                                        // }
                                      />
                                    </div>}
                                  </Col>
                                </Row>
                                <Row>
                                { selectedFRXSection?.label == "External Link" &&
                                  <Col lg={4} md={6} sm={6}>
                                    <div className="mb-3">
                                      <Label>URL</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={externalUrl}
                                        id="campaign_link_input"
                                        onChange={(e) => {
                                        setExternalUrl(e.target.value)}}
                                      />
                                    </div>
                                  </Col>}
                                </Row>
                                {selectedFRXSection?.value ==
                                  "ArticleDetail" && (
                                  <>
                                    <Row className="mb-3">
                                      <Label
                                        className="col-sm-8 col-form-label"
                                        htmlFor="formrow-firstname-input"
                                      >
                                        Blog ID
                                      </Label>
                                      <div className="col-md-10">
                                        <input
                                          className="form-control"
                                          type="text"
                                          defaultValue={
                                            navigation?.params?.data
                                          }
                                          // onChange={(e) => setFrxApp(true)}
                                          id="article_id"
                                        />
                                      </div>
                                    </Row>
                                    <Row className="mb-3">
                                      <Label
                                        className="col-sm-8 col-form-label"
                                        htmlFor="formrow-firstname-input"
                                      >
                                        Header Title
                                      </Label>
                                      <div className="col-md-10">
                                        <input
                                          className="form-control"
                                          type="text"
                                          defaultValue={
                                            isObject(navigation) &&
                                            navigation?.params?.title
                                          }
                                          // onChange={(e) => setFrxApp(true)}
                                          id="title_input_frx"
                                        />
                                      </div>
                                    </Row>
                                  </>
                                )}
                                {selectedFRXSection?.value == "StoreMainScreen" && (
                                  <Row>
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>Type</Label>
                                        <Select
                                          isSearchable={false}
                                          value={
                                            selectedSubSectionFRX.label
                                              ? selectedSubSectionFRX.label
                                              : estoreSubSections[0].label
                                          }
                                          onChange={(e) => {
                                            setSelectedCategoryFRX("");
                                            setselectedSubSectionFRX(e);
                                          }}
                                          placeholder={
                                            selectedSubSectionFRX
                                              ? selectedSubSectionFRX.label
                                              : "Choose Sub section..."
                                          }
                                          defaultValue={
                                            estoreSubSections[0].label
                                          }
                                          options={estoreSubSections}
                                          required
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                )}
                                {selectedFRXSection?.value == "StoreMainScreen" &&
                                  selectedSubSectionFRX.label !== "Blog" &&
                                  selectedSubSectionFRX?.label !==
                                    "No Navigation" && (
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>
                                            {selectedSubSectionFRX?.label ==
                                            "Category Listing"
                                              ? "Category"
                                              : "Store"}
                                          </Label>
                                          <Select
                                            isSearchable={true}
                                            value={selectedCategoryFRX}
                                            maxMenuHeight={100}
                                            menuPlacement="auto"
                                            onChange={(e) => {
                                              setSelectedCategoryFRX(e);
                                            }}
                                            placeholder={
                                              selectedCategoryFRX
                                                ? selectedCategoryFRX.label
                                                : `Choose ${
                                                    selectedSubSectionFRX?.label ==
                                                    "Category Listing"
                                                      ? "category..."
                                                      : "store..."
                                                  } `
                                            }
                                            defaultValue={""}
                                            options={
                                              selectedSubSectionFRX?.label ==
                                              "Category Listing"
                                                ? categoryOption
                                                : merchantOption
                                            }
                                            required
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                {selectedSubSectionFRX.label == "Blog" && (
                                  <>
                                    <Row>
                                      <Col lg="6">
                                        <div className="mb-3">
                                          <Label
                                            className="col-sm-8 col-form-label"
                                            htmlFor="formrow-firstname-input"
                                          >
                                            Blog ID
                                          </Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="blog_input"
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg="6">
                                        <div className="mb-3">
                                          <Label
                                            className="col-sm-8 col-form-label"
                                            htmlFor="formrow-firstname-input"
                                          >
                                            Blog Name
                                          </Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="blog_name_input"
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                              </Form>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <Card>
                              <CardBody>
                                <Form>
                                  {imageUrl && (
                                    <Row>
                                      <Col md={1}>
                                        <CardImg
                                          className="img-fluid"
                                          src={imageUrl}
                                          style={{
                                            marginBottom: 15,
                                            width: "50px",
                                          }}
                                          alt=""
                                        />
                                      </Col>
                                      <Col md={2} style={{marginTop:"auto", marginBottom:"auto"}} >
                                        <div
                                        style={{cursor:"pointer"}}
                                          className="px-3 text-danger"
                                          onClick={() => {
                                            setImageUrl("");
                                          }}
                                        >
                                          <i className="uil uil-trash-alt font-size-18"></i>Move To Trash
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  <Dropzone
                                    onDrop={(acceptedFiles) => {
                                      validateFileSize(acceptedFiles)
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div className="dropzone">
                                        <div
                                          className="dz-message needsclick"
                                          {...getRootProps()}
                                        >
                                          <input {...getInputProps()} />
                                          <div className="mb-3">
                                            <FaCloudUploadAlt className="display-4 text-muted"/>
                                          </div>
                                          <h4>
                                            Drop files here or click to upload.
                                          </h4>

                                          <p
                                            style={{
                                              fontSize: 12,
                                              color: "red",
                                            }}
                                          >
                                            Image should be 70X70px in png
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                  >
                                    {selectedFiles.map((f, i) => {
                                      return (
                                        <Card
                                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                          key={i + "-file"}
                                        >
                                          <div className="p-2">
                                            <Row className="align-items-center">
                                              <Col className="col-auto">
                                                <img
                                                  data-dz-thumbnail=""
                                                  height="80"
                                                  className="avatar-sm rounded bg-light"
                                                  alt={f.name}
                                                  src={f.preview}
                                                />
                                              </Col>
                                              <Col>
                                                <Link
                                                  to="#"
                                                  className="text-muted font-weight-bold"
                                                >
                                                  {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                  <strong>
                                                    {f.formattedSize}
                                                  </strong>
                                                </p>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      );
                                    })}
                                  </div>
                                </Form>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                // value={selectedStatus}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                        </Row>
                      </CardBody>
                    </Card>

                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/widgets");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                        {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddWidget;
